import _axios from "../plugins/axios"
import { useCallback, useEffect, useState } from "react"
import styled from "styled-components"
import { API_URL, getDaysInMonth, HOSPITAL_NAME, MONTHS, YEARS } from "../common/constant"
import Captcha from "react-captcha-code"
import { Patient } from "../common/types"

const ErrorSection = styled.section`
  display: inline-block;
  background: #eeeeee;
  color: red;
  font-weight: bold;
  padding: 12px 60px 6px;
  margin-bottom: 24px;
`

const Section = styled.section`
  width: 245px;
  background: #ffffcc;
  border: solid 2px rgb(207, 170, 255);
  margin: 0px auto;
`

const Row = styled.div`
  border-bottom: solid 2px rgb(207, 170, 255);
  padding: 2px;
  & select {
    margin: 0px 3px;
  }
`

const Info = styled.section`
  background: #eeefde;
  margin: 22px auto 0;
  text-align: left;
  width: 336px;
  padding: 6px;
  & .title {
    font-weight: bold;
    font-size: medium;
  }
  & .red {
    font-weight: bold;
    color: red;
  }
`

const CODE_MIN = 10000
const CODE_MAX = 99999
const BASIC_ERROR_MSG = "提醒您，若是初診病患無法使用網路系統預約掛號，請現場掛號。"
const NO_PATIENT_ERROR_MSG = "查無資料 請確認是否填寫正確"
const CODE_ERROR_MSG = "驗證碼輸入錯誤"

interface Props {
  onLogin: (data: Patient) => void
}
export default function Home(props: Props) {
  const { onLogin } = props
  const [type, setType] = useState<"id" | "no">("id")
  const [id, setId] = useState("")
  const [year, setYear] = useState("80")
  const [month, setMonth] = useState("1")
  const [day, setDay] = useState("1")
  const [code] = useState(String(Math.floor(Math.random() * (CODE_MAX - CODE_MIN + 1) + CODE_MIN)))
  const [userCode, setUserCode] = useState("")
  const [errorMsg, setErrorMsg] = useState<string | null>(null)

  useEffect(() => {
    setDay("1")
  }, [year, month])

  const onSubmit = useCallback(async () => {
    if (code !== userCode) {
      setErrorMsg(CODE_ERROR_MSG)
      return
    }
    const birthday = `${Number(year) + 1911}${month.padStart(2, "0")}${day.padStart(2, "0")}`

    const requestBody: Record<string, any> = {
      birthday,
    }
    if (type === "id") {
      requestBody.sidNo = id
    } else {
      requestBody.chartNo = id.padStart(8, "0")
    }

    try {
      const response = await _axios.post(API_URL.findMyself,requestBody)
      const { hixPatientId: id, name } = response.data.result
      onLogin({ id, name })
    } catch {
      setErrorMsg(NO_PATIENT_ERROR_MSG)
      return
    }

  }, [type, id, year, month, day, code, userCode, onLogin])

  return (
    <main style={{ paddingTop: "24px", textAlign: "center" }}>
      {errorMsg && (
        <ErrorSection>
          <div>{errorMsg}</div>
          <div>{BASIC_ERROR_MSG}</div>
        </ErrorSection>
      )}
      <Section>
        <form onSubmit={(event) => { event.preventDefault(); onSubmit() }}>
          <Row style={{ background: "#AAEECC" }}>{HOSPITAL_NAME}線上預約系統</Row>
          <Row>
            <input id="type-id" type="radio" name="type" value="id" defaultChecked={true} onClick={() => setType("id")} />
            <label htmlFor="type-id">身份證</label>
            <input id="type-no" type="radio" name="type" value="no" onClick={() => setType("no")} />
            <label htmlFor="type-no">病歷號碼</label>
          </Row>
          <Row>
            <input type="text" onChange={(event) => setId(event.target.value)} />
          </Row>
          <Row>出生年月日</Row>
          <Row>
            <span>民國</span>
            <select defaultValue={year} onChange={(event) => setYear(event.target.value)}>
              {YEARS.map(({ label, value }) => (
                <option value={value} key={value}>
                  {label}
                </option>
              ))}
            </select>
            <span>年</span>
            <select defaultValue="1" onChange={(event) => setMonth(event.target.value)}>
              {MONTHS.map((month) => (
                <option value={month} key={month}>
                  {month}
                </option>
              ))}
            </select>
            <span>月</span>
            <select defaultValue="1" onChange={(event) => setDay(event.target.value)}>
              {new Array(getDaysInMonth(Number(month), Number(year) + 1911))
                .fill(0)
                .map((_, idx) => (
                <option value={idx + 1} key={idx}>
                  {idx + 1}
                </option>
              ))}
            </select>
            <span>日</span>
          </Row>
          <Row>
            <Captcha code={code} charNum={5} />
            <div>請輸入上方驗證碼</div>
            <div>
              <input type="text" onChange={(event) => setUserCode(event.target.value)} />
            </div>
          </Row>
          <Row>
            <button type="submit">送出</button>
          </Row>
        </form>
      </Section>
      <Info>
        <div className="title">網路預約使用注意事項 ：</div>
        <div>☆開放使用時間：每日早上８點至晚上１０點。</div>
        <div className="red">☆不提供當日當時段之預約。</div>
        <div className="red">☆初診病患請於現場掛號。</div>
        <div>☆網路預約限制不可超過３筆預約資料，</div>
      </Info>
    </main>
  )
}
